// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * KYC VARA onboarding modal (rendered on <body>, over the current page).
 * Colours follow the existing KYC page: dark by default, gold accent, \`body.light_theme\` overrides.
 *
 * Layout: .kv-modal (blurred backdrop) > .kv-dialog > .kv-slide
 *           .kv-header  pinned top (back, title, close, step dots)
 *           .kv-body    scrolls
 *           .kv-footer  pinned bottom (main button)
 * Phones get a bottom sheet; tablets and desktop a centred dialog.
 */

/* While the modal is open the site header (z-index 9999999) must sit under the backdrop. */
body.kv-modal-open header.sticky-top {
  z-index: 99990 !important;
}

.kv-modal {
  --kv-bg: #0d0f12;
  --kv-card: #15181d;
  --kv-card-raised: #1e222a;
  --kv-border: rgba(243, 244, 246, 0.1);
  --kv-text: #f3f3f3;
  --kv-muted: #8b8f94;
  --kv-accent: #d1aa67;
  --kv-accent-soft: rgba(209, 170, 103, 0.12);
  --kv-on-accent: #070808;
  --kv-success: #22c55e;
  --kv-success-soft: rgba(34, 197, 94, 0.12);
  --kv-warning: #f5a524;
  --kv-warning-soft: rgba(245, 165, 36, 0.12);
  --kv-danger: #fb2c36;
  --kv-danger-soft: rgba(251, 44, 54, 0.12);
  --kv-info: #4f8cff;
  --kv-info-soft: rgba(79, 140, 255, 0.12);
  --kv-pad: 24px;

  /* Above every page overlay, below the Didit SDK modal (100050). */
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  animation: kv-fade-in 0.2s ease both;
}

body.light_theme .kv-modal {
  --kv-bg: #ffffff;
  --kv-card: #ffffff;
  --kv-card-raised: #f2f3f4;
  --kv-border: #e6e7e9;
  --kv-text: #303236;
  --kv-muted: #5f6368;
  --kv-accent: #b88a3e;
  --kv-accent-soft: rgba(209, 170, 103, 0.16);
  --kv-success: #15803d;
  --kv-warning: #b45309;
  --kv-danger: #dc2626;
  --kv-info: #2563eb;
  background: rgba(15, 23, 42, 0.35);
}

/* ---------- dialog ---------- */

.kv-dialog {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  height: min(680px, 88vh);
  height: min(680px, 88dvh);
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid var(--kv-border);
  background: var(--kv-bg);
  color: var(--kv-text);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.45);
  animation: kv-pop-in 0.25s ease both;
}

.kv-dialog:focus {
  outline: none;
}

.kv-slide {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* Carousel: only the content slides; the header and footer stay put. */
.kv-slide--forward .kv-body {
  animation: kv-slide-from-right 0.28s ease both;
}

.kv-slide--back .kv-body {
  animation: kv-slide-from-left 0.28s ease both;
}

/* ---------- header (pinned) ---------- */

.kv-header {
  flex: none;
  padding: 14px 16px 12px;
  border-bottom: 1px solid var(--kv-border);
}

.kv-header__bar {
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  align-items: center;
  gap: 8px;
}

.kv-header__center {
  text-align: center;
  min-width: 0;
}

.kv-header__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--kv-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kv-header__step {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--kv-muted);
}

.kv-icon-btn {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid var(--kv-border);
  background: var(--kv-card);
  color: var(--kv-text);
  font-size: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.kv-icon-btn:hover {
  border-color: var(--kv-accent);
}

.kv-icon-btn:focus-visible {
  outline: 2px solid var(--kv-accent);
  outline-offset: 2px;
}

.kv-icon-btn--placeholder {
  visibility: hidden;
}

.kv-dots {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  display: flex;
  justify-content: center;
  gap: 6px;
}

.kv-dots li {
  width: 16px;
  height: 4px;
  border-radius: 4px;
  background: var(--kv-card-raised);
  transition: width 0.25s ease, background 0.25s ease;
}

.kv-dots li.is-done {
  background: var(--kv-accent);
  opacity: 0.55;
}

.kv-dots li.is-current {
  width: 32px;
  background: var(--kv-accent);
}

/* ---------- body (scrolls) ---------- */

.kv-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 20px var(--kv-pad) 24px;
}

.kv-body--center {
  text-align: center;
}

.kv-eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--kv-accent);
}

.kv-eyebrow--warning {
  color: var(--kv-warning);
}

.kv-eyebrow--success {
  color: var(--kv-success);
}

.kv-eyebrow--danger {
  color: var(--kv-danger);
}

.kv-eyebrow--muted {
  color: var(--kv-muted);
}

.kv-title {
  margin: 0 0 8px;
  font-size: 22px;
  line-height: 1.3;
  font-weight: 700;
  color: var(--kv-text);
}

.kv-lead {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.55;
  color: var(--kv-muted);
}

.kv-section-title {
  margin: 22px 0 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--kv-muted);
}

/* ---------- cards ---------- */

.kv-card {
  background: var(--kv-card);
  border: 1px solid var(--kv-border);
  border-radius: 14px;
}

.kv-card--highlight {
  border-color: var(--kv-accent);
  background: var(--kv-accent-soft);
}

.kv-hero-icon {
  width: 64px;
  height: 64px;
  margin: 4px auto 16px;
  border-radius: 50%;
  background: var(--kv-accent-soft);
  color: var(--kv-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
}

.kv-hero-icon--success {
  background: var(--kv-success-soft);
  color: var(--kv-success);
}

.kv-hero-icon--warning {
  background: var(--kv-warning-soft);
  color: var(--kv-warning);
}

.kv-hero-icon--danger {
  background: var(--kv-danger-soft);
  color: var(--kv-danger);
}

.kv-hero-icon--muted {
  background: var(--kv-card-raised);
  color: var(--kv-muted);
}

/* ---------- start screen ---------- */

.kv-how-list {
  list-style: none;
  margin: 0;
  padding: 16px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.kv-how-list li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.kv-how-list strong {
  display: block;
  color: var(--kv-text);
  font-size: 14px;
}

.kv-how-list small {
  color: var(--kv-muted);
  font-size: 13px;
}

.kv-how-list__number {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--kv-accent-soft);
  color: var(--kv-accent);
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ---------- option cards (radio) ---------- */

.kv-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}

.kv-option {
  width: 100%;
  min-height: 64px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  text-align: left;
  background: var(--kv-card);
  border: 1px solid var(--kv-border);
  border-radius: 14px;
  color: var(--kv-text);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease;
}

.kv-option:hover:not(:disabled) {
  border-color: var(--kv-accent);
}

.kv-option:active:not(:disabled) {
  transform: scale(0.99);
}

.kv-option:focus-visible {
  outline: 2px solid var(--kv-accent);
  outline-offset: 2px;
}

.kv-option:disabled {
  cursor: default;
  opacity: 0.7;
}

.kv-option.is-selected {
  border-color: var(--kv-accent);
  background: var(--kv-accent-soft);
}

.kv-option__icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--kv-card-raised);
  color: var(--kv-text);
  font-size: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, color 0.15s ease;
}

.kv-option.is-selected .kv-option__icon {
  background: var(--kv-accent);
  color: var(--kv-on-accent);
}

.kv-option__text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.kv-option__title {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
}

.kv-option__subtitle {
  font-size: 13px;
  color: var(--kv-muted);
}

.kv-option__radio {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid var(--kv-border);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.kv-option.is-selected .kv-option__radio {
  border-color: var(--kv-accent);
  background: var(--kv-accent);
  color: var(--kv-on-accent);
}

/* Business type: six longer labels, so a little tighter. */
.kv-option--compact {
  min-height: 56px;
  padding: 10px 14px;
}

.kv-option--compact .kv-option__icon {
  width: 38px;
  height: 38px;
  font-size: 18px;
}

.kv-option--compact .kv-option__title {
  font-size: 14px;
  font-weight: 500;
}

/* ---------- notes ---------- */

.kv-note {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px 14px;
  margin-top: 12px;
  border-radius: 12px;
  text-align: left;
  background: var(--kv-info-soft);
  color: var(--kv-text);
}

.kv-note i {
  font-size: 18px;
  line-height: 1.35;
  color: var(--kv-info);
}

.kv-note p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
}

.kv-note--warning {
  background: var(--kv-warning-soft);
}

.kv-note--warning i {
  color: var(--kv-warning);
}

.kv-note--danger {
  background: var(--kv-danger-soft);
}

.kv-note--danger i {
  color: var(--kv-danger);
}

/* ---------- classification result ---------- */

.kv-result {
  padding: 18px;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px 14px;
  align-items: center;
}

.kv-result__icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: var(--kv-accent);
  color: var(--kv-on-accent);
  font-size: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.kv-result__label {
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--kv-muted);
}

.kv-result__title {
  margin: 0;
  font-size: 20px;
  line-height: 1.3;
  font-weight: 700;
  color: var(--kv-text);
}

.kv-result__reason {
  grid-column: 1 / -1;
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: var(--kv-muted);
}

/* ---------- status screen ---------- */

.kv-status-hero {
  text-align: center;
  margin-bottom: 20px;
}

.kv-status-hero .kv-lead {
  margin-bottom: 8px;
}

.kv-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
}

/* ---------- rows (checks, documents, classes) ---------- */

.kv-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.kv-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
}

.kv-row--compact {
  padding: 10px 12px;
}

.kv-row.is-current {
  border-color: var(--kv-accent);
}

.kv-row.is-dimmed .kv-row__text {
  opacity: 0.6;
}

.kv-row.is-optional {
  border-style: dashed;
  background: transparent;
}

.kv-row.is-optional .kv-row__text,
.kv-row.is-optional .kv-row__letter {
  opacity: 0.55;
}

.kv-row__icon,
.kv-row__letter {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: var(--kv-card-raised);
  color: var(--kv-text);
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.kv-row--compact .kv-row__icon {
  width: 36px;
  height: 36px;
  font-size: 17px;
}

.kv-row__icon--accent {
  background: var(--kv-accent);
  color: var(--kv-on-accent);
}

.kv-row__letter {
  font-weight: 700;
  color: var(--kv-accent);
  background: var(--kv-accent-soft);
}

.kv-row__text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.kv-row__text strong {
  font-size: 14px;
  color: var(--kv-text);
}

.kv-row__text small {
  font-size: 12px;
  color: var(--kv-muted);
  overflow-wrap: anywhere;
}

/* ---------- badges ---------- */

.kv-badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  background: var(--kv-card-raised);
  color: var(--kv-muted);
}

.kv-badge::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.kv-badge--success {
  background: var(--kv-success-soft);
  color: var(--kv-success);
}

.kv-badge--warning {
  background: var(--kv-warning-soft);
  color: var(--kv-warning);
}

.kv-badge--danger {
  background: var(--kv-danger-soft);
  color: var(--kv-danger);
}

.kv-badge--info {
  background: var(--kv-info-soft);
  color: var(--kv-info);
}

.kv-badge--accent {
  background: var(--kv-accent-soft);
  color: var(--kv-accent);
}

/* ---------- footer (pinned) and buttons ---------- */

.kv-footer {
  flex: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px var(--kv-pad) 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid var(--kv-border);
  background: var(--kv-bg);
}

.kv-btn {
  width: 100%;
  min-height: 50px;
  padding: 12px 24px;
  border-radius: 100px;
  border: 1px solid transparent;
  font-size: 15px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: filter 0.15s ease, transform 0.15s ease;
}

.kv-btn:focus-visible {
  outline: 2px solid var(--kv-accent);
  outline-offset: 3px;
}

.kv-btn--primary {
  background: var(--kv-accent);
  color: var(--kv-on-accent);
}

.kv-btn--primary:hover:not(:disabled) {
  filter: brightness(1.06);
}

.kv-btn--primary:active:not(:disabled) {
  transform: scale(0.99);
}

.kv-btn--primary:disabled {
  background: var(--kv-card-raised);
  color: var(--kv-muted);
  cursor: not-allowed;
}

.kv-btn--secondary {
  background: transparent;
  border-color: var(--kv-border);
  color: var(--kv-text);
  max-width: 240px;
}

.kv-link-btn {
  min-height: 32px;
  padding: 4px 12px;
  border: 0;
  background: none;
  color: var(--kv-muted);
  font-size: 14px;
  cursor: pointer;
}

.kv-link-btn:hover {
  color: var(--kv-text);
}

.kv-footnote {
  margin: 0;
  font-size: 12px;
  color: var(--kv-muted);
  text-align: center;
}

/* ---------- loading / error / refresh ---------- */

.kv-state {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 24px;
  text-align: center;
  color: var(--kv-muted);
}

.kv-state__icon {
  font-size: 40px;
}

.kv-refresh-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  padding: 4px 12px;
  border: 1px solid var(--kv-border);
  border-radius: 100px;
  background: transparent;
  color: var(--kv-muted);
  font-size: 13px;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.kv-refresh-btn:hover:not(:disabled) {
  color: var(--kv-text);
  border-color: var(--kv-accent);
}

.kv-refresh-btn:disabled {
  cursor: default;
}

.kv-spinner {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-right-color: transparent;
  display: inline-block;
  animation: kv-spin 0.8s linear infinite;
}

.kv-spinner--large {
  width: 36px;
  height: 36px;
  border-width: 3px;
  color: var(--kv-accent);
}

/* ---------- animations ---------- */

@keyframes kv-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes kv-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes kv-pop-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes kv-sheet-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: none;
  }
}

@keyframes kv-slide-from-right {
  from {
    opacity: 0;
    transform: translateX(40px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes kv-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-40px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

/* ---------- responsive ---------- */

/* Tablets: a bit wider, still centred. */
@media (min-width: 577px) and (max-width: 991px) {
  .kv-dialog {
    max-width: min(92vw, 540px);
  }
}

/* Short laptop screens: use more of the height. */
@media (min-width: 577px) and (max-height: 760px) {
  .kv-dialog {
    height: 94vh;
    height: 94dvh;
  }

  .kv-modal {
    padding: 12px;
  }
}

/* Phones: bottom sheet. */
@media (max-width: 576px) {
  .kv-modal {
    --kv-pad: 16px;
    padding: 0;
    align-items: flex-end;
  }

  .kv-dialog {
    max-width: none;
    height: 94vh;
    height: 94dvh;
    border-radius: 20px 20px 0 0;
    border-bottom: 0;
    animation: kv-sheet-up 0.3s ease both;
  }

  /* Drag handle look at the top of the sheet. */
  .kv-dialog::before {
    content: "";
    flex: none;
    width: 40px;
    height: 4px;
    margin: 8px auto 0;
    border-radius: 4px;
    background: var(--kv-border);
  }

  .kv-header {
    padding: 8px 12px 10px;
  }

  .kv-title {
    font-size: 20px;
  }

  .kv-result__title {
    font-size: 18px;
  }

  .kv-option {
    gap: 12px;
    padding: 12px;
  }

  .kv-option__icon {
    width: 40px;
    height: 40px;
  }

  .kv-row {
    gap: 10px;
  }
}

/* Very narrow phones: badges go under the text instead of squeezing it. */
@media (max-width: 360px) {
  .kv-row {
    flex-wrap: wrap;
  }

  .kv-row .kv-badge {
    margin-left: 52px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .kv-modal,
  .kv-dialog,
  .kv-slide--forward .kv-body,
  .kv-slide--back .kv-body,
  .kv-dots li,
  .kv-option,
  .kv-btn {
    animation: none;
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/KycVara/kycVara.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;;AAEF,2FAA2F;AAC3F;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;EAC1C,qBAAqB;EACrB,2CAA2C;EAC3C,oBAAoB;EACpB,yCAAyC;EACzC,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;;EAEd,kEAAkE;EAClE,eAAe;EACf,QAAQ;EACR,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,iCAAiC;;AAEjC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;EACrB,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,0CAA0C;;AAE1C;EACE,UAAU;EACV,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA;EACE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA,yCAAyC;;AAEzC;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gCAAgC;;AAEhC;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;EACjC,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,uCAAuC;;AAEvC;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,+CAA+C;;AAE/C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gDAAgD;;AAEhD;EACE,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,wCAAwC;;AAExC;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA,4DAA4D;;AAE5D;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,iCAAiC;;AAEjC;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA,sDAAsD;;AAEtD;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,6DAA6D;EAC7D,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,oDAAoD;;AAEpD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,qCAAqC;;AAErC;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,qCAAqC;;AAErC,yCAAyC;AACzC;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,cAAc;IACd,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;IAChB,qCAAqC;EACvC;;EAEA,8CAA8C;EAC9C;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,0EAA0E;AAC1E;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;;;;;;IAOE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * KYC VARA onboarding modal (rendered on <body>, over the current page).\n * Colours follow the existing KYC page: dark by default, gold accent, `body.light_theme` overrides.\n *\n * Layout: .kv-modal (blurred backdrop) > .kv-dialog > .kv-slide\n *           .kv-header  pinned top (back, title, close, step dots)\n *           .kv-body    scrolls\n *           .kv-footer  pinned bottom (main button)\n * Phones get a bottom sheet; tablets and desktop a centred dialog.\n */\n\n/* While the modal is open the site header (z-index 9999999) must sit under the backdrop. */\nbody.kv-modal-open header.sticky-top {\n  z-index: 99990 !important;\n}\n\n.kv-modal {\n  --kv-bg: #0d0f12;\n  --kv-card: #15181d;\n  --kv-card-raised: #1e222a;\n  --kv-border: rgba(243, 244, 246, 0.1);\n  --kv-text: #f3f3f3;\n  --kv-muted: #8b8f94;\n  --kv-accent: #d1aa67;\n  --kv-accent-soft: rgba(209, 170, 103, 0.12);\n  --kv-on-accent: #070808;\n  --kv-success: #22c55e;\n  --kv-success-soft: rgba(34, 197, 94, 0.12);\n  --kv-warning: #f5a524;\n  --kv-warning-soft: rgba(245, 165, 36, 0.12);\n  --kv-danger: #fb2c36;\n  --kv-danger-soft: rgba(251, 44, 54, 0.12);\n  --kv-info: #4f8cff;\n  --kv-info-soft: rgba(79, 140, 255, 0.12);\n  --kv-pad: 24px;\n\n  /* Above every page overlay, below the Didit SDK modal (100050). */\n  position: fixed;\n  inset: 0;\n  z-index: 100000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  animation: kv-fade-in 0.2s ease both;\n}\n\nbody.light_theme .kv-modal {\n  --kv-bg: #ffffff;\n  --kv-card: #ffffff;\n  --kv-card-raised: #f2f3f4;\n  --kv-border: #e6e7e9;\n  --kv-text: #303236;\n  --kv-muted: #5f6368;\n  --kv-accent: #b88a3e;\n  --kv-accent-soft: rgba(209, 170, 103, 0.16);\n  --kv-success: #15803d;\n  --kv-warning: #b45309;\n  --kv-danger: #dc2626;\n  --kv-info: #2563eb;\n  background: rgba(15, 23, 42, 0.35);\n}\n\n/* ---------- dialog ---------- */\n\n.kv-dialog {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 480px;\n  height: min(680px, 88vh);\n  height: min(680px, 88dvh);\n  overflow: hidden;\n  border-radius: 20px;\n  border: 1px solid var(--kv-border);\n  background: var(--kv-bg);\n  color: var(--kv-text);\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.45);\n  animation: kv-pop-in 0.25s ease both;\n}\n\n.kv-dialog:focus {\n  outline: none;\n}\n\n.kv-slide {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Carousel: only the content slides; the header and footer stay put. */\n.kv-slide--forward .kv-body {\n  animation: kv-slide-from-right 0.28s ease both;\n}\n\n.kv-slide--back .kv-body {\n  animation: kv-slide-from-left 0.28s ease both;\n}\n\n/* ---------- header (pinned) ---------- */\n\n.kv-header {\n  flex: none;\n  padding: 14px 16px 12px;\n  border-bottom: 1px solid var(--kv-border);\n}\n\n.kv-header__bar {\n  display: grid;\n  grid-template-columns: 40px 1fr 40px;\n  align-items: center;\n  gap: 8px;\n}\n\n.kv-header__center {\n  text-align: center;\n  min-width: 0;\n}\n\n.kv-header__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--kv-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.kv-header__step {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: var(--kv-muted);\n}\n\n.kv-icon-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  border: 1px solid var(--kv-border);\n  background: var(--kv-card);\n  color: var(--kv-text);\n  font-size: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.kv-icon-btn:hover {\n  border-color: var(--kv-accent);\n}\n\n.kv-icon-btn:focus-visible {\n  outline: 2px solid var(--kv-accent);\n  outline-offset: 2px;\n}\n\n.kv-icon-btn--placeholder {\n  visibility: hidden;\n}\n\n.kv-dots {\n  list-style: none;\n  margin: 12px 0 0;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  gap: 6px;\n}\n\n.kv-dots li {\n  width: 16px;\n  height: 4px;\n  border-radius: 4px;\n  background: var(--kv-card-raised);\n  transition: width 0.25s ease, background 0.25s ease;\n}\n\n.kv-dots li.is-done {\n  background: var(--kv-accent);\n  opacity: 0.55;\n}\n\n.kv-dots li.is-current {\n  width: 32px;\n  background: var(--kv-accent);\n}\n\n/* ---------- body (scrolls) ---------- */\n\n.kv-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 20px var(--kv-pad) 24px;\n}\n\n.kv-body--center {\n  text-align: center;\n}\n\n.kv-eyebrow {\n  margin: 0 0 6px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--kv-accent);\n}\n\n.kv-eyebrow--warning {\n  color: var(--kv-warning);\n}\n\n.kv-eyebrow--success {\n  color: var(--kv-success);\n}\n\n.kv-eyebrow--danger {\n  color: var(--kv-danger);\n}\n\n.kv-eyebrow--muted {\n  color: var(--kv-muted);\n}\n\n.kv-title {\n  margin: 0 0 8px;\n  font-size: 22px;\n  line-height: 1.3;\n  font-weight: 700;\n  color: var(--kv-text);\n}\n\n.kv-lead {\n  margin: 0 0 20px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--kv-muted);\n}\n\n.kv-section-title {\n  margin: 22px 0 10px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--kv-muted);\n}\n\n/* ---------- cards ---------- */\n\n.kv-card {\n  background: var(--kv-card);\n  border: 1px solid var(--kv-border);\n  border-radius: 14px;\n}\n\n.kv-card--highlight {\n  border-color: var(--kv-accent);\n  background: var(--kv-accent-soft);\n}\n\n.kv-hero-icon {\n  width: 64px;\n  height: 64px;\n  margin: 4px auto 16px;\n  border-radius: 50%;\n  background: var(--kv-accent-soft);\n  color: var(--kv-accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 30px;\n}\n\n.kv-hero-icon--success {\n  background: var(--kv-success-soft);\n  color: var(--kv-success);\n}\n\n.kv-hero-icon--warning {\n  background: var(--kv-warning-soft);\n  color: var(--kv-warning);\n}\n\n.kv-hero-icon--danger {\n  background: var(--kv-danger-soft);\n  color: var(--kv-danger);\n}\n\n.kv-hero-icon--muted {\n  background: var(--kv-card-raised);\n  color: var(--kv-muted);\n}\n\n/* ---------- start screen ---------- */\n\n.kv-how-list {\n  list-style: none;\n  margin: 0;\n  padding: 16px;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.kv-how-list li {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.kv-how-list strong {\n  display: block;\n  color: var(--kv-text);\n  font-size: 14px;\n}\n\n.kv-how-list small {\n  color: var(--kv-muted);\n  font-size: 13px;\n}\n\n.kv-how-list__number {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--kv-accent-soft);\n  color: var(--kv-accent);\n  font-size: 13px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ---------- option cards (radio) ---------- */\n\n.kv-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.kv-option {\n  width: 100%;\n  min-height: 64px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px;\n  text-align: left;\n  background: var(--kv-card);\n  border: 1px solid var(--kv-border);\n  border-radius: 14px;\n  color: var(--kv-text);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease;\n}\n\n.kv-option:hover:not(:disabled) {\n  border-color: var(--kv-accent);\n}\n\n.kv-option:active:not(:disabled) {\n  transform: scale(0.99);\n}\n\n.kv-option:focus-visible {\n  outline: 2px solid var(--kv-accent);\n  outline-offset: 2px;\n}\n\n.kv-option:disabled {\n  cursor: default;\n  opacity: 0.7;\n}\n\n.kv-option.is-selected {\n  border-color: var(--kv-accent);\n  background: var(--kv-accent-soft);\n}\n\n.kv-option__icon {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: var(--kv-card-raised);\n  color: var(--kv-text);\n  font-size: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.kv-option.is-selected .kv-option__icon {\n  background: var(--kv-accent);\n  color: var(--kv-on-accent);\n}\n\n.kv-option__text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.kv-option__title {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.kv-option__subtitle {\n  font-size: 13px;\n  color: var(--kv-muted);\n}\n\n.kv-option__radio {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 2px solid var(--kv-border);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.kv-option.is-selected .kv-option__radio {\n  border-color: var(--kv-accent);\n  background: var(--kv-accent);\n  color: var(--kv-on-accent);\n}\n\n/* Business type: six longer labels, so a little tighter. */\n.kv-option--compact {\n  min-height: 56px;\n  padding: 10px 14px;\n}\n\n.kv-option--compact .kv-option__icon {\n  width: 38px;\n  height: 38px;\n  font-size: 18px;\n}\n\n.kv-option--compact .kv-option__title {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* ---------- notes ---------- */\n\n.kv-note {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  padding: 12px 14px;\n  margin-top: 12px;\n  border-radius: 12px;\n  text-align: left;\n  background: var(--kv-info-soft);\n  color: var(--kv-text);\n}\n\n.kv-note i {\n  font-size: 18px;\n  line-height: 1.35;\n  color: var(--kv-info);\n}\n\n.kv-note p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.kv-note--warning {\n  background: var(--kv-warning-soft);\n}\n\n.kv-note--warning i {\n  color: var(--kv-warning);\n}\n\n.kv-note--danger {\n  background: var(--kv-danger-soft);\n}\n\n.kv-note--danger i {\n  color: var(--kv-danger);\n}\n\n/* ---------- classification result ---------- */\n\n.kv-result {\n  padding: 18px;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 12px 14px;\n  align-items: center;\n}\n\n.kv-result__icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: var(--kv-accent);\n  color: var(--kv-on-accent);\n  font-size: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.kv-result__label {\n  margin: 0 0 2px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--kv-muted);\n}\n\n.kv-result__title {\n  margin: 0;\n  font-size: 20px;\n  line-height: 1.3;\n  font-weight: 700;\n  color: var(--kv-text);\n}\n\n.kv-result__reason {\n  grid-column: 1 / -1;\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--kv-muted);\n}\n\n/* ---------- status screen ---------- */\n\n.kv-status-hero {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.kv-status-hero .kv-lead {\n  margin-bottom: 8px;\n}\n\n.kv-summary {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n}\n\n/* ---------- rows (checks, documents, classes) ---------- */\n\n.kv-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kv-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n}\n\n.kv-row--compact {\n  padding: 10px 12px;\n}\n\n.kv-row.is-current {\n  border-color: var(--kv-accent);\n}\n\n.kv-row.is-dimmed .kv-row__text {\n  opacity: 0.6;\n}\n\n.kv-row.is-optional {\n  border-style: dashed;\n  background: transparent;\n}\n\n.kv-row.is-optional .kv-row__text,\n.kv-row.is-optional .kv-row__letter {\n  opacity: 0.55;\n}\n\n.kv-row__icon,\n.kv-row__letter {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  background: var(--kv-card-raised);\n  color: var(--kv-text);\n  font-size: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.kv-row--compact .kv-row__icon {\n  width: 36px;\n  height: 36px;\n  font-size: 17px;\n}\n\n.kv-row__icon--accent {\n  background: var(--kv-accent);\n  color: var(--kv-on-accent);\n}\n\n.kv-row__letter {\n  font-weight: 700;\n  color: var(--kv-accent);\n  background: var(--kv-accent-soft);\n}\n\n.kv-row__text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.kv-row__text strong {\n  font-size: 14px;\n  color: var(--kv-text);\n}\n\n.kv-row__text small {\n  font-size: 12px;\n  color: var(--kv-muted);\n  overflow-wrap: anywhere;\n}\n\n/* ---------- badges ---------- */\n\n.kv-badge {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 100px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  background: var(--kv-card-raised);\n  color: var(--kv-muted);\n}\n\n.kv-badge::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.kv-badge--success {\n  background: var(--kv-success-soft);\n  color: var(--kv-success);\n}\n\n.kv-badge--warning {\n  background: var(--kv-warning-soft);\n  color: var(--kv-warning);\n}\n\n.kv-badge--danger {\n  background: var(--kv-danger-soft);\n  color: var(--kv-danger);\n}\n\n.kv-badge--info {\n  background: var(--kv-info-soft);\n  color: var(--kv-info);\n}\n\n.kv-badge--accent {\n  background: var(--kv-accent-soft);\n  color: var(--kv-accent);\n}\n\n/* ---------- footer (pinned) and buttons ---------- */\n\n.kv-footer {\n  flex: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 14px var(--kv-pad) 16px;\n  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));\n  border-top: 1px solid var(--kv-border);\n  background: var(--kv-bg);\n}\n\n.kv-btn {\n  width: 100%;\n  min-height: 50px;\n  padding: 12px 24px;\n  border-radius: 100px;\n  border: 1px solid transparent;\n  font-size: 15px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  cursor: pointer;\n  transition: filter 0.15s ease, transform 0.15s ease;\n}\n\n.kv-btn:focus-visible {\n  outline: 2px solid var(--kv-accent);\n  outline-offset: 3px;\n}\n\n.kv-btn--primary {\n  background: var(--kv-accent);\n  color: var(--kv-on-accent);\n}\n\n.kv-btn--primary:hover:not(:disabled) {\n  filter: brightness(1.06);\n}\n\n.kv-btn--primary:active:not(:disabled) {\n  transform: scale(0.99);\n}\n\n.kv-btn--primary:disabled {\n  background: var(--kv-card-raised);\n  color: var(--kv-muted);\n  cursor: not-allowed;\n}\n\n.kv-btn--secondary {\n  background: transparent;\n  border-color: var(--kv-border);\n  color: var(--kv-text);\n  max-width: 240px;\n}\n\n.kv-link-btn {\n  min-height: 32px;\n  padding: 4px 12px;\n  border: 0;\n  background: none;\n  color: var(--kv-muted);\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.kv-link-btn:hover {\n  color: var(--kv-text);\n}\n\n.kv-footnote {\n  margin: 0;\n  font-size: 12px;\n  color: var(--kv-muted);\n  text-align: center;\n}\n\n/* ---------- loading / error / refresh ---------- */\n\n.kv-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  padding: 24px;\n  text-align: center;\n  color: var(--kv-muted);\n}\n\n.kv-state__icon {\n  font-size: 40px;\n}\n\n.kv-refresh-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 32px;\n  padding: 4px 12px;\n  border: 1px solid var(--kv-border);\n  border-radius: 100px;\n  background: transparent;\n  color: var(--kv-muted);\n  font-size: 13px;\n  cursor: pointer;\n  transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.kv-refresh-btn:hover:not(:disabled) {\n  color: var(--kv-text);\n  border-color: var(--kv-accent);\n}\n\n.kv-refresh-btn:disabled {\n  cursor: default;\n}\n\n.kv-spinner {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  display: inline-block;\n  animation: kv-spin 0.8s linear infinite;\n}\n\n.kv-spinner--large {\n  width: 36px;\n  height: 36px;\n  border-width: 3px;\n  color: var(--kv-accent);\n}\n\n/* ---------- animations ---------- */\n\n@keyframes kv-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes kv-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes kv-pop-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@keyframes kv-sheet-up {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: none;\n  }\n}\n\n@keyframes kv-slide-from-right {\n  from {\n    opacity: 0;\n    transform: translateX(40px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@keyframes kv-slide-from-left {\n  from {\n    opacity: 0;\n    transform: translateX(-40px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n/* ---------- responsive ---------- */\n\n/* Tablets: a bit wider, still centred. */\n@media (min-width: 577px) and (max-width: 991px) {\n  .kv-dialog {\n    max-width: min(92vw, 540px);\n  }\n}\n\n/* Short laptop screens: use more of the height. */\n@media (min-width: 577px) and (max-height: 760px) {\n  .kv-dialog {\n    height: 94vh;\n    height: 94dvh;\n  }\n\n  .kv-modal {\n    padding: 12px;\n  }\n}\n\n/* Phones: bottom sheet. */\n@media (max-width: 576px) {\n  .kv-modal {\n    --kv-pad: 16px;\n    padding: 0;\n    align-items: flex-end;\n  }\n\n  .kv-dialog {\n    max-width: none;\n    height: 94vh;\n    height: 94dvh;\n    border-radius: 20px 20px 0 0;\n    border-bottom: 0;\n    animation: kv-sheet-up 0.3s ease both;\n  }\n\n  /* Drag handle look at the top of the sheet. */\n  .kv-dialog::before {\n    content: \"\";\n    flex: none;\n    width: 40px;\n    height: 4px;\n    margin: 8px auto 0;\n    border-radius: 4px;\n    background: var(--kv-border);\n  }\n\n  .kv-header {\n    padding: 8px 12px 10px;\n  }\n\n  .kv-title {\n    font-size: 20px;\n  }\n\n  .kv-result__title {\n    font-size: 18px;\n  }\n\n  .kv-option {\n    gap: 12px;\n    padding: 12px;\n  }\n\n  .kv-option__icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .kv-row {\n    gap: 10px;\n  }\n}\n\n/* Very narrow phones: badges go under the text instead of squeezing it. */\n@media (max-width: 360px) {\n  .kv-row {\n    flex-wrap: wrap;\n  }\n\n  .kv-row .kv-badge {\n    margin-left: 52px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .kv-modal,\n  .kv-dialog,\n  .kv-slide--forward .kv-body,\n  .kv-slide--back .kv-body,\n  .kv-dots li,\n  .kv-option,\n  .kv-btn {\n    animation: none;\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
